export const API_ENDPOINTS = {
  QUESTION: {
    FETCH_OKTA_CONFIG: 'Home/GetOktaConfigDetails',
    SAVE_FOLDER: 'Question/SaveFolder',
    COPY_FOLDER: 'Question/CopyFolder',
    SAVE: 'Question/SaveQuestion',
    GET_QUESTION: 'Question/GetQuestion',
    EDIT_FOLDER: 'Question/EditFolder',
    FOLDER_LIST: 'Question/GetFolderList',
    DELETE: 'Question/DeleteQuestions',
    MAIN_QUESTION_LIST: 'Question/GetMainQuestionList',
    IMPORT_NEW_QUESTION_LIST: 'Question/ImportNewQuestionList',
    QUESTIONS_TO_EXPORT: 'Question/GetQuestionsToExport',
    GET_TOKEN: 'Question/GetAccessToken',
    UNMAPPED_QUESTION_LIST: 'Question/GetUnmappedQuestionList',
    QUESTIONS_BY_CATEGORY_VIEW_QUESTIONS: 'Question/GetQuestionsByCategoryViewQuestions',
    QUESTIONS_BY_FOLDER_VIEW_QUESTIONS: 'Question/GetQuestionsByFolderViewQuestions',
    QUESTION_CATEGORY_LIST: 'Question/GetQuestionCategoryList',
    MAP_QUESTION_TO_FOLDER: 'Question/MapQuestionToFolder',
    CLEAR_QUESTION_LIST_CATCHE: 'Question/ClearQuestioListCache',
    LANGUAGE_SETTINGS: 'Question/GetAllQuestionLanguageSettings',
    SAVE_DESCRIPTION: 'Question/SaveQuestionDescription',
    PREVIEW: 'Question/PreviewQuestion',
    COPY: 'Question/CopyQuestion',
    DETAILS: 'Question/GetQuestionDetails',
    SAVE_CATEGORY: 'Question/SaveQuestionCategory',
    SAVE_INPUT_TYPE: 'Question/SaveQuestionInputType',
    INFO_URL: 'Question/GetQuestionInfo',
    LANGUAGE_LIST: 'Question/GetLanguagesList',
    SAVE_OPTION_LANGUAGE_SETTINGS: 'Question/SaveQuestionOptionsLanguageSettings',
    OPTION_MAPPED_LIST: 'Question/GetQuestionOptionsLanguageMappedList',
    DELETE_OPTION_LANUGAGE_DETAILS: 'Question/DeleteQuestionOptionsLanguageDetails',
    SCHEMA_LIST: 'Question/GetSchemaList',
    GRADING_SCHEMA: 'Question/GetGradingSchema',
    GRADING_SCHEMA_LIST: 'Question/GetGradingSchemaList',
    UPSERT_GRADING_SCHEMA: 'Question/CreateUpdateGradingSchema',
    SAVE_DATE_TIME_QUESTION: 'Question/SaveDateTimeQuestionType',
  },
  QUESTION_MATRIX: {
    SAVE_QUESTION: 'QuestionMatrix/SaveQuestion',
    SAVE_COLUMN_HEADER: 'QuestionMatrix/SaveColumnHeader',
    SAVE_ROW_ITEM: 'QuestionMatrix/SaveRowItem',
    SAVE_COLUMN_DATA: 'QuestionMatrix/SaveColumnData',
    SAVE_DEFAULT_VALUE: 'QuestionMatrix/SaveDefaultValue',
    SAVE_RANGE_COLUMN_DATA: 'QuestionMatrix/SaveRangeColumnData',
    QUESTION_ITEM_LIST: 'QuestionMatrix/GetAllQuestionItemList',
    COLUMN_DATA: 'QuestionMatrix/GetColumndata',
    MATRIX_QUESTION_DATA: 'QuestionMatrix/GetMatrixQuestionData',
    PICK_LIST_REFERENCE_MEMBERS: 'QuestionMatrix/GetPicklistReferenceMembers',
    ARRANGE_COLUMN_HEADER: 'QuestionMatrix/ArrangeColumnHeader',
    ARRANGE_COLUMN_ITEM: 'QuestionMatrix/ArrangeColumnItem',
    ARRANGE_ROW_ITEM: 'QuestionMatrix/ArrangeRowItem',
    DELETE_COLUMN_HEADER: 'QuestionMatrix/DeleteColumnHeader',
    DELETE_COLUMN_ITEM: 'QuestionMatrix/DeleteColumnItem',
    DELETE_ROW_ITEM: 'QuestionMatrix/DeleteRowItem',
    DELETE_DEFAULT_VALUE: 'QuestionMatrix/DeleteDefaultValue',
    SURVEY_MATRIX_CONDITIONAL_SETTINGS: 'QuestionMatrix/GetSurveyMatrixConditionalSettings',
  },
  MULTICHOICE: {
    QUESTIONS: 'MultiChoice/GetQuestions',
    OPTIONS: 'MultiChoice/GetOptions',
    SAVE_QUESTION: 'MultiChoice/SaveQuestion',
    ADD_OPTION: 'MultiChoice/AddOption',
    REMOVE_OPTION: 'MultiChoice/RemoveOption',
    ARRANGE_QUESTION_OPTION: 'MultiChoice/ArrangeQuestionOption',
  },
  SURVEY: {
    COPY: 'Survey/CopySurvey',
    SURVEY_LIST: 'Survey/GetSurveyList',
    DELETE: 'Survey/DeleteSurvey',
    MAP_QUESTION_TO_SECTION: 'Survey/MapQuestionToSection',
    LANGUAGE_MAPPED_DETAILS: 'Survey/GetSurveyProviderLanguageMappedDetails',
    GET_WORKSPACE_ID: 'Survey/GetWorkspaceID',
    SURVEY_SCHEMA: 'Survey/GetSurveySchema',
    SECTION_CONFIG: 'Survey/GetSectionConfigration',
    UI_ATTRIBUTE_BY_ID: 'Survey/GetUIAttributesByIdentifierID',
    UPDATE_SURVEY_RESPONSE: 'Survey/UpdateSurveyResponseDataOnEditUrl',
    PROGRESS_BAR_CONFIG: 'Survey/GetSurveyProgressBarConfigurations',
    COMPANY_LOGO: 'Survey/GetCompanyLogo',
    SURVEY_MESSAGES: 'Survey/GetSurveyMessages',
    LANGUAGES: 'Survey/GetLanguageList',
    SURVEY_MESSAGES_AND_LANGUAGES: 'Survey/GetSurveyMessagesAndLanguage',
    ADAPTIVE_ASSSESMENT_SETTINGS: 'Survey/GetAdaptiveAssessmentSettings',
    OPTION_SECTION_SETTINGS: 'Survey/GetOptionAndSectionSettings',
    MERGE_CODE_SETTINGS: 'Survey/GetMergeCodeSettings',

  },
  SECTION: {
    LIST: 'SurveySection/GetSectionList',
    SAVE: 'SurveySection/SaveSection',
    DELETE: 'SurveySection/DeleteSectionItem',
    EDIT: 'SurveySection/EditSection',
  },
  SETTING: {
    LIST: 'Setting/GetSettingList',
    SAVE: 'Setting/SaveSetting',
    EDIT: 'Setting/EditSetting',
    DELETE: 'Setting/DeleteSetting',
    MAP_SECTION: 'Setting/MapSectionToSetting',
    UN_MAP_SECTION: 'Setting/UnMapSectionToSetting',
    ARRANGE_SECTION: 'Setting/ArrangeSection',
    MAPPED_SECTION_LIST: 'Setting/GetMappedSectionList',
    UN_MAPPED_SECTION_LIST: 'Setting/GetUnmappedSectionList',
    OCTA_CONFIG: "Home/GetOktaConfigDetails",
  },
  USER: {
    LIST_DETAILS: 'User/GetUserListDetails',
    ROLES: 'User/GetRoleItem',
    COMPANIES: 'User/GetCompanyNameAndID',
    SERVICE_LINES: 'User/GetServiceLines',
    SURVEYS: 'User/GetSurveyList',
    EDIT: 'User/EditUserItem',
    SAVE: 'User/Saveuser',
    DELETE: 'User/deleteUserItem',
    BULK_SAVE: 'User/SaveBulkUser',
    EMAIL_TEMPLATE: 'User/EmailTemplate',
    SEND_NEWSLETTER: 'User/SendMaillNewsLetter',
    MASTER_LIST: 'User/GetMasterUserList',
    OKTA_SAVE: 'User/GetAccessTokenForCreateUser',
    OKTA_ACTIVATE: 'User/ActivateOktaUser',
  },
  COMPANY: {
    LIST: 'Company/GetCompanyList',
    SAVE: 'Company/SaveCompany',
    NEW: 'Company/NewCompany',
    EDIT: 'Company/EditCompany',
    DELETE: 'Company/DeleteCompany',
    MASTER_LIST: 'Company/GetMasterCompanyList',
  },
  SURVEY_SERVICE_LINE: {
    LIST: 'SurveyServiceLine/GetServiceLineList',
    SAVE: 'SurveyServiceLine/SaveServiceLineList',
    EDIT: 'SurveyServiceLine/EditServiceLineList',
    DELETE: 'SurveyServiceLine/DeleteServiceLineItem',
    MAPPED_SERVICE_PROVIDERS: 'SurveyServiceLine/GetMappedServiceProviderList',
    MAPPED_SURVEYS: 'SurveyServiceLine/GetMappedSurveyList',
    MAPPED_LINK: 'SurveyServiceLine/GetMappedlink',
    LINK_LIST: 'SurveyServiceLine/GetLinkList',
    SAVE_LINK: 'SurveyServiceLine/Savelink',
    CLIENT_ADMIN_LIST: 'SurveyServiceLine/GetClientAdminList',
    ENROLLED_PRODUCTS: 'SurveyServiceLine/GetEnrolledProductList',
    ACTIVE_PRODUCT: 'SurveyServiceLine/GetActiveProduct',
    ALL_GROUPS: 'SurveyServiceLine/GetAllGroupsByServiceLine',
    DELETE_GROUP: 'SurveyServiceLine/DeleteGroup',
    MAP_USER_TO_GROUP: 'SurveyServiceLine/MapUserToGroup',
    GRID_HEADER: 'SurveyServiceLine/GetGridHeader',
  },
  MANAGE_SERVICE_LINE: {
    // ── Survey mapping ────────────────────────────────────────────────────────
    MAPPED_SURVEY_LIST: 'ManageServiceLine/GetMappedSurveyList',
    MAPPED_SURVEY_LIST_PRODUCTS: 'ManageServiceLine/GetMappedSurveyListForProducts',
    UNMAPPED_SURVEY_LIST: 'ManageServiceLine/GetUnMappedSurveyList',
    MAP_SURVEY: 'ManageServiceLine/MapSurveyToServiceLine',
    UNMAP_SURVEY: 'ManageServiceLine/UnMapSurveyFromServiceLine',
    UPDATE_SURVEY_MAP: 'ManageServiceLine/UpdateSurveyMap',
    UPDATE_MASTER_TEMPLATE: 'ManageServiceLine/UpdateMasterTemplate',

    // ── Service provider mapping ──────────────────────────────────────────────
    MAPPED_PROVIDER_LIST: 'ManageServiceLine/GetMappedServiceProviderList',
    UNMAPPED_PROVIDER_LIST: 'ManageServiceLine/GetUnMappedServiceProviderList',
    MAP_PROVIDER: 'ManageServiceLine/MapServiceProviderToServiceLine',
    UNMAP_PROVIDER: 'ManageServiceLine/UnMapServiceProviderFromServiceLine',

    // ── Schedule ──────────────────────────────────────────────────────────────
    EDIT_SURVEY_SCHEDULE: 'ManageServiceLine/EditSurveySchedule',
    SAVE_SURVEY_SCHEDULE: 'ManageServiceLine/SaveSurveySchedule',

    // ── Copy / delete ─────────────────────────────────────────────────────────
    COPY_SURVEY: 'ManageServiceLine/CopySurvey',
    DELETE_SURVEY_SERVICE_LINE: 'ManageServiceLine/DeleteSurveyServiceLine',
    DELETE_COMPANY_SERVICE_LINE: 'ManageServiceLine/DeleteCompanyServiceLine',

    // ── Template / respondent ─────────────────────────────────────────────────
    SAVE_TEMPLATE: 'ManageServiceLine/SaveTemplate',
    GET_RESPONDENTS: 'ManageServiceLine/GetRespondents',
    SAVE_RESPONDENT_TYPE: 'ManageServiceLine/SaveRepondentType',

    // ── Users / status ────────────────────────────────────────────────────────
    GET_ALL_USERS_BY_COMPANY: 'ManageServiceLine/GetAllUsersByCompany',
    UPDATE_EXCEPTIONAL_USER: 'ManageServiceLine/UpdateExceptionalUserDetails',
    GET_ALL_STATUS: 'ManageServiceLine/GetAllStatus',

    // ── Documents ─────────────────────────────────────────────────────────────
    GET_DOCUMENT_LIST: 'ManageServiceLine/GetDocumentById',
    UPLOAD_DOCUMENT: 'ManageServiceLine/UploadDocument',
    DOWNLOAD_DOCUMENT: 'ManageServiceLine/DownLoadDocument',
    DELETE_DOCUMENT: 'ManageServiceLine/DeleteDocument',

    // ── Format / upload ───────────────────────────────────────────────────────
    FORMAT_DOWNLOAD: 'ManageServiceLine/FormatDown',
    USER_DOWNLOAD: 'ManageServiceLine/UserdownLoad',
    UPLOAD_ANSWERS: 'ManageServiceLine/UploadAnswers',

    // ── Email / assessment ────────────────────────────────────────────────────
    GET_EMAIL_DETAILS: 'ManageServiceLine/GetServicelineEmailDetails',
    SAVE_EMAIL_DETAILS: 'ManageServiceLine/SaveServicelineEmailDetails',

    // ── Language ──────────────────────────────────────────────────────────────
    LANGUAGE_MAPPED_LIST: 'ManageServiceLine/GetSurveyServiceLineLanguageMappedList',
    SAVE_PROVIDER_LANGUAGE: 'ManageServiceLine/SaveSurveyProviderLanguageSettings',
    DELETE_SURVEY_COMPANY_LANGUAGE: 'ManageServiceLine/DeleteSurveyCompanyLanguage',

    // ── Consip ────────────────────────────────────────────────────────────────
    IS_CONSIP: 'ManageServiceLine/IsConsipServiceLine',

    // ── Survey (shared) ───────────────────────────────────────────────────────
    GET_LANGUAGE_LIST: 'ManageServiceLine/GetLanguageList',
  }
}
